var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v("© "+_vm._s(new Date().getFullYear())+".")])]),_c('div',{staticClass:"ml-2"},[_c('span',{staticClass:"mr-1"},[_vm._v(" ")]),_c('lang-dropdown')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }